import { supabase } from "@/integrations/supabase/client";

export interface UserKeywordProgress {
  id?: string;
  userId: string;
  certificationId: string;
  chapterId: string;
  keywordsMastered: number;
  keywordsTotal: number;
  lastScore: number;
  exerciseType: string | null;
  updatedAt?: string;
}

type Listener = () => void;
let _items: UserKeywordProgress[] = [];
let _loaded = false;
const listeners = new Set<Listener>();
const notify = () => listeners.forEach((fn) => fn());

export const userKeywordProgressStore = {
  get: () => _items,
  subscribe: (fn: Listener) => {
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  },
  isLoaded: () => _loaded,

  async loadForUser(userId: string) {
    if (!userId) return;
    const { data, error } = await supabase
      .from("user_keyword_progress" as any)
      .select("*")
      .eq("user_id", userId);
    if (error) {
      console.error("Failed to load keyword progress:", error);
      return;
    }
    _items = (data || []).map((r: any) => ({
      id: r.id,
      userId: r.user_id,
      certificationId: r.certification_id,
      chapterId: r.chapter_id,
      keywordsMastered: r.keywords_mastered,
      keywordsTotal: r.keywords_total,
      lastScore: r.last_score,
      exerciseType: r.exercise_type,
      updatedAt: r.updated_at,
    }));
    _loaded = true;
    notify();
  },

  async upsert(progress: UserKeywordProgress) {
    const { error } = await supabase
      .from("user_keyword_progress" as any)
      .upsert({
        user_id: progress.userId,
        certification_id: progress.certificationId,
        chapter_id: progress.chapterId,
        keywords_mastered: progress.keywordsMastered,
        keywords_total: progress.keywordsTotal,
        last_score: progress.lastScore,
        exercise_type: progress.exerciseType,
      }, { onConflict: "user_id,chapter_id" });

    if (error) {
      console.error("Failed to upsert keyword progress:", error);
      return;
    }

    const idx = _items.findIndex(
      (p) => p.userId === progress.userId && p.chapterId === progress.chapterId
    );
    if (idx >= 0) {
      _items[idx] = { ..._items[idx], ...progress };
    } else {
      _items.push(progress);
    }
    _items = [..._items];
    notify();
  },

  reset() {
    _items = [];
    _loaded = false;
    notify();
  },
};
